import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'central'
})
export class CentralPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
